import ActionManager from '../ActionManager';

import Login from './Login';
ActionManager.register(Login, ['stores:MainStore']);

import Logout from './Logout';
ActionManager.register(Logout, ['stores:MainStore']);

import SignUp from './SignUp';
ActionManager.register(SignUp, ['stores:MainStore']);